'use strict';

var _ = require('lodash');
var SummaryTopOppTransformerFactory = function SummaryTopOppTransformerFactory(DataTransformer, filterService) {
  function SummaryTopOppTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['rom-summary-top-opp-spill-mode', 'rom-summary-top-opp-recap-mode'];
    this.targetType = ['rom-summary-top-recap', 'rom-summary-top-spill'];
  }
  SummaryTopOppTransformer.prototype = Object.create(DataTransformer.prototype);
  SummaryTopOppTransformer.constructor = SummaryTopOppTransformer;
  SummaryTopOppTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) > -1 && this.targetType.indexOf(targetType) > -1;
  };
  SummaryTopOppTransformer.prototype.getCacheKey = function (metrics, metricDescriptor, sourceType) {
    return sourceType + '-' + metrics.join('-');
  };
  SummaryTopOppTransformer.prototype.isCacheable = function () {
    return true;
  };
  function parseMarketCabinSposOpp(toParse) {
    var parsed = toParse.split('.');
    return {
      market: parsed[0],
      cabin: parsed[1],
      spos: parsed[2]
    };
  }
  SummaryTopOppTransformer.prototype.transform = function (data) {
    var optGroupWeekOpportunities = data.domain.optGroupWeekOpportunityList;
    var categoryRules = filterService.prepareFilterRules();
    var result = [];
    for (var index = 0; index < optGroupWeekOpportunities.length; index++) {
      var opportunity = optGroupWeekOpportunities[index];
      var marketCabinSPOSOpps = _.keys(opportunity.marketCabinSPOSOpps);
      for (var i = 0; i < marketCabinSPOSOpps.length; i++) {
        var marketCabinSPOSOppString = marketCabinSPOSOpps[i];
        var marketCabinSPOSOppElement = opportunity.marketCabinSPOSOpps[marketCabinSPOSOppString];
        var parsedMarketCabinSPOSOpp = parseMarketCabinSposOpp(marketCabinSPOSOppString);
        var fullEntry = {
          optGroupWeek: opportunity.optGroupWeek,
          market: parsedMarketCabinSPOSOpp.market,
          cabin: parsedMarketCabinSPOSOpp.cabin,
          spos: parsedMarketCabinSPOSOpp.spos,
          revGap: marketCabinSPOSOppElement.revenueGap,
          paxGap: marketCabinSPOSOppElement.paxGap,
          rank: marketCabinSPOSOppElement.rank,
          nbOfOccurrences: marketCabinSPOSOppElement.pastOccurrences + marketCabinSPOSOppElement.currentOccurrences
        };
        if (filterService.isFulfillingSearchRules(fullEntry, categoryRules)) {
          result.push(fullEntry);
        }
      }
    }
    return result;
  };
  return SummaryTopOppTransformer;
};
SummaryTopOppTransformerFactory.$inject = ['DataTransformerFactory', 'FilterDataAtTransformerUsingSearchRulesService'];
module.exports = SummaryTopOppTransformerFactory;